import React, { useEffect, useState } from 'react';
import { Alert, Button, Collapse } from '@mui/material';
import HandshakeIcon from '@mui/icons-material/Handshake';
import { useNavigate } from 'react-router-dom';

const STORAGE_KEY = 'excubia.partnerBanner.dismissedAt';
const SHOW_AGAIN_AFTER_DAYS = 14;

/**
 * In-app "we're looking for a partner" notice. Users can close it; it comes back after
 * SHOW_AGAIN_AFTER_DAYS. Dismissal is remembered per browser only.
 */
const PartnerBanner = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const dismissedAt = Number(window.localStorage.getItem(STORAGE_KEY) || 0);
      const due = !dismissedAt || Date.now() - dismissedAt > SHOW_AGAIN_AFTER_DAYS * 86400000;
      setOpen(due);
    } catch (e) {
      setOpen(true);
    }
  }, []);

  const dismiss = () => {
    setOpen(false);
    try { window.localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (e) { /* private mode */ }
  };

  return (
    <Collapse in={open} unmountOnExit>
      <Alert
        severity="info"
        icon={<HandshakeIcon fontSize="inherit" />}
        onClose={dismiss}
        data-testid="partner-banner"
        action={
          <>
            <Button color="inherit" size="small" onClick={() => navigate('/partner')} sx={{ mr: 1, whiteSpace: 'nowrap' }}>
              Get in touch
            </Button>
            <Button color="inherit" size="small" onClick={dismiss}>Dismiss</Button>
          </>
        }
        sx={{ mb: 2, alignItems: 'center' }}
      >
        <strong>Looking for a design partner.</strong> We want to work with a security team or MSSP to build out integrations and shape Excubia together. Tell us what you would like to see.
      </Alert>
    </Collapse>
  );
};

export default PartnerBanner;
